import { Button, SelectMenu } from "@focus/focusUI";

interface UploadPanelHeaderProps {
  canUpload: boolean;
  fileCount: number;
  onOriginChange: (origin: string) => void;
  onReset: () => void;
  onUploadAll: () => void;
  organizations: string[];
  origin?: string;
  stagedFileCount: number;
}

export const UploadPanelHeader = ({
  canUpload,
  fileCount,
  onOriginChange,
  onReset,
  onUploadAll,
  organizations,
  origin,
  stagedFileCount,
}: UploadPanelHeaderProps) => (
  <header className="flex flex-wrap items-start justify-between gap-4 border-b border-slate-200 bg-white px-4 py-4">
    <div className="min-w-0 flex gap-5">
      <h2 className="mt-1 text-lg font-bold text-slate-950">
        Upload Orbit Files
      </h2>
      <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm font-medium text-slate-500">
        <span>{fileCount} queued</span>
        <span className="text-slate-300">/</span>
        <span>{stagedFileCount} staged</span>
        {origin && (
          <>
            <span className="text-slate-300">/</span>
            <span>{origin}</span>
          </>
        )}
      </div>
    </div>

    <div className="flex flex-wrap items-end gap-3">
      <label className="focusoc-form-shell flex min-w-[240px] gap-2 items-center">
        <span className="text-xs font-semibold uppercase text-slate-500">
          Organization
        </span>
        <SelectMenu
          onChange={onOriginChange}
          value={origin}
          options={organizations}
        />
      </label>

      <div className="flex items-center gap-2">
        <Button
          className="focusoc-icon-button focusoc-icon-button-danger"
          disabled={fileCount === 0}
          icon="trash"
          minimal
          onClick={onReset}
          title="Clear all"
        />
        <Button
          className="focusoc-primary-button"
          disabled={!canUpload}
          icon="circle-arrow-up"
          onClick={onUploadAll}
        >
          Upload all
        </Button>
      </div>
    </div>
  </header>
);

